import { inject, Injectable } from '@angular/core';
import { SharedPatientAssistancePharmacyEnrollmentGroupVo } from '@libs/shared/domain/patient-assistance/pharmacy/enrollment-group/shared-patient-assistance-pharmacy-enrollment-group.vo';
import { ProgramGroupService } from '@services/program-group.service';
import { Store } from '@services/store';

@Injectable({ providedIn: 'root' })
export class ProgramGroupsStore extends Store<SharedPatientAssistancePharmacyEnrollmentGroupVo[]> {
  private readonly service = inject(ProgramGroupService);

  protected getDataSource(key: string) {
    return this.service.getProgramGroupsForTenant(key);
  }
}
